import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, Text, View } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { EInvoiceType } from '@linqpal/models'
import capitalize from 'lodash/capitalize'
import moment from 'moment'
import { Divider } from 'react-native-paper'
import { currencyMask } from '../../../../../utils/helpers/masking'
import { PayableStatusLabel } from '../../../../../ui/molecules/StatusLabel/PayableStatusLabel'
import {
  PaidInvoiceStatuses,
  PaymentProcessingInvoiceStatuses,
} from '../../../PayablesTab/enums'

export const OtherInvoiceInfo: React.FC<{
  invoice: any
  isMobile: boolean
}> = ({ invoice, isMobile }) => {
  const { t } = useTranslation('global')

  const remainingAmount =
    PaymentProcessingInvoiceStatuses.includes(invoice.status) ||
    PaidInvoiceStatuses.includes(invoice.status)
      ? 0
      : invoice.totalRemainingAmount

  const width = isMobile ? '100%' : 360

  const dueDate = moment(invoice.invoice_due_date).format('MM/DD/YYYY')
  const dueLabel =
    invoice.type === EInvoiceType.INVOICE
      ? t('Receivables.due-on', { date: dueDate })
      : ''

  return (
    <View style={{ width, paddingHorizontal: 5 }}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Text style={composeStyle(styles.normalText, { maxWidth: '50%' })}>
          {`${capitalize(invoice?.type).replace('_', ' ')} #${
            invoice.invoice_number
          }`}
        </Text>
        <Text style={styles.valueText}>{dueLabel}</Text>
      </View>
      <Divider style={styles.divider} />
      <StatusDisplay
        status={invoice.status}
        label={t('TabInvoice.InvoiceStatus')}
      />
      <Divider style={styles.divider} />
      <AmountDisplay
        amount={invoice.total_amount}
        label={t('TabInvoice.InvoiceAmount')}
      />
      <Divider style={styles.divider} />
      <AmountDisplay
        amount={remainingAmount}
        label={t('TabInvoice.RemainingAmount')}
        valueStyle={remainingAmount ? { fontWeight: '700' } : {}}
      />
      <Divider style={styles.divider} />
    </View>
  )
}

const AmountDisplay = ({ amount, label, valueStyle = {} }) => (
  <View style={styles.amountTypeContainer}>
    <Text style={composeStyle(styles.normalText, { maxWidth: '50%' })}>
      {label}
    </Text>
    <Text style={[styles.valueText, valueStyle]}>{currencyMask(amount)}</Text>
  </View>
)

const StatusDisplay = ({ status, label }) => (
  <View style={styles.amountTypeContainer}>
    <Text style={composeStyle(styles.normalText, { maxWidth: '50%' })}>
      {label}
    </Text>
    <View style={{ marginTop: 5 }}>
      <PayableStatusLabel status={status} />
    </View>
  </View>
)

const styles = StyleSheet.create({
  normalText: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
    color: '#758590',
    fontFamily: 'Inter',
  },
  valueText: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Inter',
    fontWeight: '500',
    maxWidth: '50%',
    textAlign: 'right',
    color: '#001929',
  },
  statusValue: {
    maxWidth: '50%',
  },
  amountTypeContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 26,
  },
  divider: {
    marginTop: 14,
    marginBottom: 14,
  },
  labelStyle: {
    color: '#99ADBA',
    marginTop: 7,
  },
})
